import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          // Navbar
          onelink: "Home",
          twolink: "Services",
          threelink: "Blog",
          fourlink: "About Company",
          fivelink: "Join Us",
          order_button: "Order Quote",

          // Hero Section
          textone: "Eye Note Tech",
          texttwo: "Pioneers in Building",
          textthree: "E-Commerce Stores, Websites & Apps",
          buttonone: "Join Us",
          buttontwo: "Latest Project",

          // Services Cards
          team: "Our Team",
          text_team: "Our team consists of top specialists in design, development, and marketing, united by passion to turn your ideas into successful digital realities.",

          web: "Web & App Development",
          text_web: "We deliver end-to-end solutions for websites and mobile apps to strengthen your digital presence and drive business growth.",

          marketing: "Marketing Services",
          text_marketing: "Smart marketing solutions including content management, ad campaigns, and SEO to help you reach your target audience effectively.",

          // هنا التصليح: غيرنا analsysis إلى analysis
          analysis: "Analytics & Insights",
          text_analysis: "Data-driven insights to optimize your strategies with advanced analytics and tailored reporting services.",

          cyber: "Cybersecurity Solutions",
          text_cyber: "Protect your digital assets with robust services including audits, threat detection, and secure architecture.",

          cloud: "Cloud Services",
          text_cloud: "Scale your business with reliable cloud solutions offering seamless integration, storage, and high-performance management.",

          // About Section
          about: "About Us",
          after_about: "+5 Years of Experience",
          text_about: "iNote Tech is a specialized digital agency in digital marketing, website development, and mobile applications. We create innovative solutions that help our clients grow and stand out in the digital market. We work with passion and deliver real results.",

          onebranch: "Technical Support",
          text_onebranch: "At iNote Tech, we care about your experience after delivery as much as the project quality. We provide continuous technical support to ensure your website or app runs smoothly, and we’re always ready to solve any issue professionally and quickly.",

          twobranch: "Tech Solutions",
          text_twobranch: "We offer a complete package of tech solutions including planning, development, and marketing — turning your idea into a seamless digital reality that achieves your goals with minimal effort and maximum return.",

          // Vision Section
          vision_title: "Our Vision",
          vision_tags: "Innovation • Growth • Success",
          vision_shorttext: "To empower businesses with innovative digital solutions that drive growth, efficiency, and long-term success.",

          vision_point1: "At iNote Tech, we aspire to be the leading technology partner for businesses across the Arab world by delivering smart, integrated, and precisely crafted digital solutions that keep pace with market developments and contribute to our clients’ long-term success.",
          vision_point2: "We envision a future where innovation and technology are accessible to every business, empowering them to thrive in a competitive digital landscape. Our goal is to bridge the gap between ideas and execution through reliable, scalable, and user-centric solutions.",
          vision_point3: "By combining creativity, technical expertise, and strategic thinking, we aim to redefine how businesses interact with technology. We believe in building digital ecosystems that are functional and future-ready—designed to evolve with your growth.",
          vision_point4: "Our vision goes beyond development; it’s about creating meaningful impact. Whether it’s a startup seeking its first online presence or an enterprise pursuing digital transformation, iNote Tech is committed to being your trusted partner every step of the way.",

          vision_experience: "Years of Experience",

          // Testimonials
          name_client: "Client Testimonials",
          text_client: "Your Digital Partner for Success",

          oneperson: "Sara Ahmed",
          track_one: "UI/UX Designer",
          text_person: "The UI/UX track transformed the way I design interfaces. It helped me understand user behavior and build clean, modern layouts.",

          twoperson: "Mohamed Ali",
          track_two: "Full Stack Developer",
          text_twoperson: "The full-stack track gave me real confidence in both frontend and backend. The projects were practical and pushed me to think like a real engineer.",

          threeperson: "Lina Youssef",
          track_three: "Mobile App Developer",
          text_threeperson: "The mobile development track helped me build real apps with smooth UI and strong performance. Highly recommended for beginners.",

          fourperson: "Karim Hassan",
          track_four: "Backend Developer",
          text_fourperson: "The backend track strengthened my understanding of APIs, databases, and server logic. The hands-on projects were incredibly useful.",

          fiveperson: "Nour Adel",
          track_five: "Data Analyst",
          text_fiveperson: "The data analysis track taught me how to work with real datasets, visualize insights, and build dashboards. Great for analytical minds.",

          sixperson: "Mido Gaber",
          track_six: "Data Analyst",
          text_sixperson: "The data analysis track taught me how to work with real datasets, visualize insights, and build dashboards. Great for analytical minds.",

          // start services 
          our_services: "Our Services",
          trusted_projects: "200+ Trusted Projects",
          webser: "Web Development",
          text_webser: "We build fast, scalable websites using modern frameworks and clean code. Whether it's a landing page or a full-stack app, we deliver seamless digital experiences.",
          uiux: "UI/UX Design",
          text_uiux: "Our design team creates intuitive interfaces that engage users and drive results. We focus on usability, accessibility, and visual harmony across all devices.",
          branding: "Branding & Identity",
          text_branding: "We help businesses stand out with custom logos, color schemes, and design systems that reflect their values and connect with their audience.",
          documentation: "Technical Documentation",
          text_documentation: "We craft bilingual, professional documentation that simplifies complex systems and enhances product clarity for global users and developers.",
          consulting: "Consulting & Strategy",
          text_consulting: "From project planning to deployment, we offer expert guidance to help you make informed tech decisions and scale your digital presence effectively.",
          ceo: "CEO Founder & Manager",
          text_ceo: "Leading the vision and execution, bringing years of expertise to transform ideas into successful digital products and businesses.",

          // start project 
          our_projects: "Our Projects",
          projects_description: "Here’s a glimpse of some of our work and the technical solutions we’ve delivered in web and app development and design.",
          project_dashboard: "Restaurant Order Management Dashboard",
          project_title: "Dashboard for Seamless Restaurant Order Management",
          project_desc1: "We offer a smart bus booking system that empowers transport companies to manage trips, seats, and payments with ease and flexibility. It provides users with a smooth and secure booking experience through a simple interface that supports real-time tracking and instant updates.",
          project_desc2: "Our solution is designed to streamline operations, reduce manual errors, and enhance customer satisfaction. With intuitive controls and instant notifications, both administrators and users enjoy a hassle-free experience tailored to modern transportation needs.",
          project_desc3: "By integrating advanced features like automated scheduling, digital payments, and live trip monitoring, the system ensures efficiency for companies and convenience for passengers alike.",
          project_desc4: "The platform also supports detailed analytics and reporting, helping businesses gain insights into performance, optimize routes, and improve decision-making.",
          project_desc5: "With scalability in mind, our solution adapts to small operators and large fleets alike, ensuring long-term growth and sustainability in the evolving transport industry.",

          // start footer
          footer_company_description: "We are a leading software company specializing in building modern web applications, mobile solutions, and innovative digital platforms.",
          footer_quick_links: "Quick Links",
          footer_about_us: "About Us",
          footer_services: "Services",
          footer_products: "Products",
          footer_contact: "Contact",
          footer_careers: "Careers",
          footer_support: "Support",
          footer_faq: "FAQ",
          footer_help_center: "Help Center",
          footer_privacy_policy: "Privacy Policy",
          footer_terms_of_service: "Terms of Service",
          footer_contact_support: "Contact Support",
          footer_newsletter: "Newsletter",
          footer_newsletter_text: "Subscribe to our newsletter for updates, news, and exclusive offers.",
          footer_enter_email: "Enter your email",
          footer_copyright: "iNote Tech. All rights reserved.",

          // start background
          join_us: "Join Us | iNoteTech",
          description: "Topics that inspire you and keep up with the latest trends in technology, design, and digital marketing",
          // start info 
          alt1: "Intuitive UI & Requirements Analysis",
    text1: "We specialize in crafting intuitive user interfaces and conducting precise requirements analysis to ensure your software is both functional and user-friendly. Our team delivers scalable solutions tailored to your business needs, with ongoing support to keep your project thriving.",

    alt2: "Flexible Software & Marketing Campaigns",
    text2: "Our expertise lies in developing flexible and robust software solutions, complemented by strategic marketing campaigns. We provide end-to-end services, from concept design to post-launch support, ensuring your project achieves long-term success.",

    alt3: "Responsive Websites & Scalable Apps",
    text3: "We focus on building responsive websites and scalable applications, with a strong emphasis on user experience and technical reliability. Our comprehensive approach includes regular updates and dedicated support to drive your project forward.",

    alt4: "Innovative Development & Marketing Strategies",
    text4: "Our services encompass innovative software development and dynamic website creation, paired with effective marketing strategies. We ensure seamless project execution from initial planning to final delivery, with continuous optimization for success.",

    alt5: "Custom Solutions & Market Analysis",
    text5: "We deliver customized software solutions and engaging web designs, backed by thorough market analysis and ongoing maintenance. Our goal is to transform your vision into reality with reliable, high-quality services that ensure project longevity.",

    alt6: "User-Centric Software & Strategic Support",
    text6: "Our team excels in creating user-centric software and websites, supported by strategic marketing and consistent technical support. We guide your project from ideation to execution, ensuring adaptability and success in a competitive landscape.",
    // start backblog
    titleblog: "Blog | iNoteTech",
    descriptionblog: "Topics that inspire you and keep up with the latest trends in technology, design, and digital marketing",
    // start blog and track
   track_title: "Explore the iNoteTech Blog",
track_description:
"Discover insightful articles that inspire your creativity and keep you ahead in the world of technology, design, and digital marketing.",

track_front_end_title: "Front-End Developer",
track_front_end_article:
"A Front-End Developer is responsible for transforming designs into interactive user interfaces that users see and interact with directly. This track focuses on HTML, CSS, JavaScript, and React, with an emphasis on performance, responsiveness, and user experience.",

track_back_end_title: "Back-End Developer",
track_back_end_article:
"A Back-End Developer is the backbone of any application, handling servers, databases, and business logic using technologies such as Node.js and Express. This role focuses on security, performance, and efficient data management.",

track_ui_ux_title: "UI / UX Designer",
track_ui_ux_article:
"A UI/UX Designer focuses on how users interact with a product and how it feels to use it. This track combines creativity and analysis to build intuitive and user-friendly digital experiences.",

track_full_stack_title: "Full Stack Developer",
track_full_stack_article:
"A Full Stack Developer combines both front-end and back-end skills, enabling them to build complete applications from start to deployment. This track is ideal for those who enjoy challenges and continuous learning.",

track_mobile_title: "Mobile App Developer",
track_mobile_article:
"A Mobile App Developer builds applications for Android and iOS using modern frameworks such as React Native and Flutter. This field is rapidly growing and offers great opportunities for innovation and freelancing.",

track_digital_marketing_title: "Digital Marketing",
track_digital_marketing_article:
"Digital Marketing focuses on promoting products and services online through search engine optimization, paid advertising, and performance analysis to achieve measurable growth.",

track_graphic_design_title: "Graphic Designer",
track_graphic_design_article:
"A Graphic Designer is responsible for creating visual identities for brands, from logos to marketing materials, combining creativity with visual consistency.",

track_devops_title: "DevOps Engineer",
track_devops_article:
"A DevOps Engineer automates deployment and continuous integration processes using CI/CD tools and cloud services to ensure system stability and scalability.",

track_data_analyst_title: "Data Analyst",
track_data_analyst_article:
"A Data Analyst transforms raw data into meaningful insights by analyzing information and building dashboards that support smarter business decisions.",

track_ai_engineer_title: "AI Engineer",
track_ai_engineer_article:
"An AI Engineer develops intelligent systems using machine learning and data analysis techniques to create advanced solutions that drive technological innovation.",
// start company
companytitle: "Our Work | iNoteTech",
companysubtitle: "Topics that inspire you and keep up with the latest trends in technology, design, and digital marketing",
// start three section

  "about": {
    "title": "About Us",
    "experience": "+5 Years of Experience",
    "description": "iNote Tech is a specialized digital agency in digital marketing, website development, and mobile applications. We design innovative solutions that help our clients grow and stand out in the digital market. We work with passion and deliver real results.",
    "support": {
      "title": "Technical Support",
      "text": "At iNote Tech, we ensure smooth performance with fast, reliable support."
    },
    "solutions": {
      "title": "Tech Solutions",
      "text": "At iNote Tech, we turn ideas into digital reality."
    }
  },
  "vision": {
    "title": "Leading the Future of Digital Transformation",
    "subtitle": "+ Our Vision",
    "description": "We believe that technology is not just a set of tools—it’s the foundation of progress and sustainability. Our vision is to become the leading tech partner for companies seeking smart growth, by delivering integrated software and marketing solutions that adapt to market shifts and exceed customer expectations.",
    "innovation": {
      "title": "Continuous Innovation",
      "text": "At iNoteTech, we continuously evolve our solutions to stay ahead of the latest tech trends."
    },
    "partnership": {
      "title": "Long-Term Partnership",
      "text": "At iNoteTech, we build lasting relationships with our clients based on trust and ongoing support to achieve mutual success."
    }
  },
  // start join
  "join": {
    "title": "Join Us | iNoteTech",
    "subtitle": "Topics that inspire you and keep up with the latest trends in technology, design, and digital marketing"
  },
  // start login
  login_title: "Welcome Back",
  login_subtitle: "Please login to your account",
  login_email: "Email Address",
  login_password: "Password",
  login_button: "Login",
  login_brand: "iNote Tech",
  login_tagline: "Your Digital Partner"


        }
      },
      ar: {
        translation: {
          // Navbar
          onelink: "الرئيسية",
          twolink: "الخدمات",
          threelink: "المدونة",
          fourlink: "عن الشركة",
          fivelink: "انضم إلينا",
          order_button: "طلب تسعيرة",

          // Hero Section
          textone: "آي نوت تك",
          texttwo: "رواد في بناء",
          textthree: "متاجر ومواقع وتطبيقات إلكترونية",
          buttonone: "انضم إلينا",
          buttontwo: "آخر مشروع",

          // Services Cards
          team: "فريقنا",
          text_team: "يضم فريقنا نخبة من المتخصصين في التصميم والتطوير والتسويق، يجمعهم الشغف لتحويل أفكارك إلى واقع رقمي ناجح.",

          web: "تطوير المواقع والتطبيقات",
          text_web: "نقدم حلولاً شاملة لتصميم المواقع وتطوير التطبيقات لتعزيز حضورك الرقمي ودعم نمو أعمالك.",

          marketing: "خدمات التسويق",
          text_marketing: "حلول تسويقية ذكية تشمل إدارة المحتوى، الحملات الإعلانية، وتحسين محركات البحث للوصول إلى جمهورك بفعالية.",

          // هنا التصليح: غيرنا analsysis إلى analysis
          analysis: "التحليلات والرؤى",
          text_analysis: "استفد من تحليلات مبنية على البيانات لتحسين استراتيجياتك من خلال خدماتنا المتقدمة.",

          cyber: "حلول الأمن السيبراني",
          text_cyber: "احمِ أصولك الرقمية بخدمات أمنية متقدمة تشمل التدقيق، كشف التهديدات، وتصميم الأنظمة الآمنة.",

          cloud: "خدمات السحابة",
          text_cloud: "نمِّ أعمالك بحلول سحابية موثوقة توفر تكاملاً سلساً، تخزيناً، وإدارة عالية الأداء.",

          // About Section
          about: "من نحن",
          after_about: "+5 سنوات خبرة",
          text_about: "آي نوت تك هي وكالة رقمية متخصصة في التسويق الرقمي، تطوير المواقع، وتطبيقات الموبايل. نصمم حلولاً مبتكرة تساعد عملاءنا على النمو والتميز في السوق الرقمي. نعمل بشغف ونقدم نتائج حقيقية.",

          onebranch: "الدعم الفني",
          text_onebranch: "في آي نوت تك، نهتم بتجربة العميل بعد التسليم بنفس قدر اهتمامنا بجودة المشروع. نوفر دعماً فنياً مستمراً لضمان عمل موقعك أو تطبيقك بكفاءة، ونكون دائماً جاهزين لحل أي استفسار أو مشكلة بسرعة واحترافية.",

          twobranch: "الحلول التقنية",
          text_twobranch: "نقدم باقة متكاملة من الحلول التقنية تشمل التخطيط والتطوير والتسويق، لتحويل فكرتك إلى تجربة رقمية سلسة تحقق أهدافك بأقل جهد وأعلى عائد.",

          // Vision Section
          vision_title: "رؤيتنا",
          vision_tags: "الابتكار • النمو • النجاح",
          vision_shorttext: "تمكين الشركات من خلال حلول رقمية مبتكرة تدعم النمو والكفاءة والنجاح المستدام.",

          vision_point1: "في آي نوت تك، نطمح لأن نكون الشريك التقني الرائد للشركات في العالم العربي من خلال تقديم حلول رقمية ذكية ومتكاملة ومصممة بدقة تواكب تطورات السوق وتسهم في نجاح عملائنا على المدى الطويل.",
          vision_point2: "نؤمن بمستقبل تكون فيه التكنولوجيا والابتكار متاحين لكل شركة، مما يساعدها على الازدهار في سوق رقمي تنافسي. هدفنا ربط الأفكار بالتنفيذ عبر حلول موثوقة وقابلة للتوسع ومتمحورة حول المستخدم.",
          vision_point3: "من خلال الجمع بين الإبداع والخبرة التقنية والتفكير الاستراتيجي، نسعى لإعادة تعريف طريقة تفاعل الشركات مع التكنولوجيا، وبناء منظومات رقمية عملية وقابلة للتطور بما يتماشى مع نمو أعمالك.",
          vision_point4: "رؤيتنا تتجاوز التطوير فقط؛ فهي تتمحور حول صناعة تأثير حقيقي. سواء كنت شركة ناشئة تبحث عن أول حضور رقمي أو مؤسسة تسعى للتحول الرقمي، تلتزم آي نوت تك بأن تكون الشريك الموثوق في كل خطوة.",

          vision_experience: "سنوات من الخبرة",

          // Testimonials
          name_client: "آراء العملاء",
          text_client: "شريكك الرقمي نحو النجاح",

          oneperson: "سارة أحمد",
          track_one: "مصممة واجهات وتجربة مستخدم",
          text_person: "مسار الـ UI/UX غيّر طريقة تصميمي للواجهات. ساعدني على فهم سلوك المستخدم وبناء تصاميم حديثة ونظيفة.",

          twoperson: "محمد علي",
          track_two: "مطور متكامل (Full Stack)",
          text_twoperson: "مسار الـ Full-Stack منحني ثقة حقيقية في الواجهة الأمامية والخلفية. المشاريع كانت عملية ودفعتني للتفكير كمهندس حقيقي.",

          threeperson: "لينا يوسف",
          track_three: "مطور تطبيقات موبايل",
          text_threeperson: "مسار تطوير التطبيقات ساعدني على بناء تطبيقات فعلية بواجهة سلسة وأداء قوي. أنصح به بشدة للمبتدئين.",

          fourperson: "كريم حسن",
          track_four: "مطور خلفية (Backend)",
          text_fourperson: "مسار الـ Backend عزّز فهمي للـ APIs وقواعد البيانات ومنطق السيرفر. المشاريع العملية كانت مفيدة جداً.",

          fiveperson: "نور عادل",
          track_five: "محللة بيانات",
          text_fiveperson: "مسار تحليل البيانات علّمني التعامل مع البيانات الحقيقية، استخراج الرؤى، وبناء لوحات معلومات. رائع للعقول التحليلية.",

          sixperson: "ميدو جابر",
          track_six: "محلل بيانات",
          text_sixperson: "مسار تحليل البيانات علّمني التعامل مع البيانات الحقيقية، استخراج الرؤى، وبناء لوحات معلومات. رائع للعقول التحليلية.",

          // start services
          our_services: "خدماتنا",
          trusted_projects: "أكثر من 200 مشروع موثوق",
          webser: "تطوير المواقع",
          text_webser: "نبني مواقع سريعة وقابلة للتوسع باستخدام أحدث الإطارات وكود نظيف. سواء صفحة هبوط أو تطبيق كامل، نقدم تجربة رقمية سلسة.",
          uiux: "تصميم واجهات وتجربة المستخدم",
          text_uiux: "فريق التصميم لدينا يصنع واجهات بديهية تجذب المستخدمين وتحقق النتائج. نركز على السهولة والوصولية والتناسق البصري عبر جميع الأجهزة.",
          branding: "الهوية البصرية والعلامة التجارية",
          text_branding: "نساعد الشركات على التميز من خلال شعارات مخصصة، ألوان مميزة، وأنظمة تصميم تعكس قيمهم وترتبط بجمهورهم.",
          documentation: "التوثيق الفني",
          text_documentation: "نصنع توثيقًا احترافيًا ثنائي اللغة يبسط الأنظمة المعقدة ويوفر وضوحًا للمستخدمين والمطورين حول العالم.",
          consulting: "الاستشارات والاستراتيجية",
          text_consulting: "من التخطيط للمشروع حتى التنفيذ، نقدم إرشادًا خبيرًا لمساعدتك على اتخاذ قرارات تقنية مدروسة وتوسيع حضورك الرقمي.",
          ceo: "الرئيس التنفيذي والمؤسس والمدير",
          text_ceo: "يقود الرؤية والتنفيذ بخبرة تمتد لسنوات، يحول الأفكار إلى منتجات رقمية ناجحة وأعمال مزدهرة.",

          // start project 
          our_projects: "مشاريعنا",
          projects_description: "إليك لمحة عن بعض أعمالنا والحلول التقنية التي قدمناها في تطوير المواقع والتطبيقات والتصميم.",
          project_dashboard: "لوحة تحكم إدارة طلبات المطاعم",
          project_title: "لوحة تحكم لإدارة طلبات المطاعم بسلاسة",
          project_desc1: "نقدم نظام حجز حافلات ذكي يمكّن شركات النقل من إدارة الرحلات والمقاعد والمدفوعات بسهولة ومرونة. يوفر للمستخدمين تجربة حجز سلسة وآمنة من خلال واجهة بسيطة تدعم التتبع في الوقت الفعلي والتحديثات الفورية.",
          project_desc2: "حلنا مصمم لتبسيط العمليات، تقليل الأخطاء اليدوية، وزيادة رضا العملاء. مع تحكم بديهي وإشعارات فورية، يستمتع كل من المدراء والمستخدمين بتجربة خالية من التعقيد تتناسب مع احتياجات النقل الحديث.",
          project_desc3: "من خلال دمج ميزات متقدمة مثل الجدولة الآلية، الدفع الإلكتروني، ومراقبة الرحلات المباشرة، يضمن النظام كفاءة للشركات وراحة للركاب على حد سواء.",
          project_desc4: "المنصة تدعم أيضًا التحليلات والتقارير التفصيلية، مما يساعد الشركات على الحصول على رؤى حول الأداء، تحسين المسارات، واتخاذ قرارات أفضل.",
          project_desc5: "مع الأخذ في الاعتبار قابلية التوسع، يتكيف حلنا مع المشغلين الصغار والأساطيل الكبيرة على حد سواء، مما يضمن نموًا طويل الأمد واستدامة في صناعة النقل المتطورة.",

          // start footer
          footer_company_description: "نحن شركة برمجيات رائدة متخصصة في بناء تطبيقات ويب حديثة، حلول الهواتف الذكية، والمنصات الرقمية المبتكرة.",
          footer_quick_links: "روابط سريعة",
          footer_about_us: "من نحن",
          footer_services: "الخدمات",
          footer_products: "المنتجات",
          footer_contact: "تواصل معنا",
          footer_careers: "الوظائف",
          footer_support: "الدعم",
          footer_faq: "الأسئلة الشائعة",
          footer_help_center: "مركز المساعدة",
          footer_privacy_policy: "سياسة الخصوصية",
          footer_terms_of_service: "شروط الخدمة",
          footer_contact_support: "اتصل بالدعم",
          footer_newsletter: "النشرة البريدية",
          footer_newsletter_text: "اشترك في نشرتنا البريدية للحصول على التحديثات والأخبار والعروض الحصرية.",
          footer_enter_email: "أدخل بريدك الإلكتروني",
          footer_copyright: "iNote Tech. جميع الحقوق محفوظة.",

          // start background
          join_us: "انضم إلينا | iNoteTech",
          description: "مواضيع تلهمك وتتماشى مع آخر الاتجاهات في التكنولوجيا والتصميم والتسويق الرقمي",
          // start info
          alt1: "واجهات مستخدم بديهية وتحليل متطلبات دقيق",
    text1: "نختص في تصميم واجهات مستخدم بديهية وإجراء تحليل متطلبات دقيق لضمان أن يكون برنامجك عملياً وسهل الاستخدام. فريقنا يقدم حلولاً قابلة للتوسع مصممة خصيصاً لاحتياجات أعمالك، مع دعم مستمر لضمان استمرار نجاح مشروعك.",

    alt2: "حلول برمجية مرنة وحملات تسويقية استراتيجية",
    text2: "نمتلك خبرة في تطوير حلول برمجية مرنة وقوية، مدعومة بحملات تسويقية استراتيجية. نقدم خدمات شاملة من تصميم الفكرة إلى الدعم بعد الإطلاق، لضمان نجاح مشروعك على المدى الطويل.",

    alt3: "مواقع متجاوبة وتطبيقات قابلة للتوسع",
    text3: "نركز على بناء مواقع متجاوبة وتطبيقات قابلة للتوسع، مع تركيز قوي على تجربة المستخدم والموثوقية التقنية. نهجنا الشامل يشمل تحديثات دورية ودعم مخصص لدفع مشروعك للأمام.",

    alt4: "تطوير مبتكر واستراتيجيات تسويق فعالة",
    text4: "تشمل خدماتنا تطوير برمجيات مبتكرة وإنشاء مواقع ديناميكية، مع استراتيجيات تسويق فعالة. نضمن تنفيذ المشروع بسلاسة من التخطيط الأولي إلى التسليم النهائي، مع تحسين مستمر للنجاح.",

    alt5: "حلول مخصصة وتحليل سوق شامل",
    text5: "نقدم حلول برمجية مخصصة وتصاميم مواقع جذابة، مدعومة بتحليل سوق شامل وصيانة مستمرة. هدفنا تحويل رؤيتك إلى واقع باستخدام خدمات موثوقة وعالية الجودة تضمن استمرارية المشروع.",

    alt6: "برمجيات تركز على المستخدم ودعم استراتيجي",
    text6: "يتفوق فريقنا في إنشاء برمجيات ومواقع تركز على المستخدم، مدعومة بالتسويق الاستراتيجي والدعم التقني المستمر. نرشد مشروعك من الفكرة إلى التنفيذ، لضمان التكيف والنجاح في بيئة تنافسية.",
    titleblog: "المدونة | آي نوت تك",
    descriptionblog: "مواضيع تلهمك وتتماشى مع أحدث الاتجاهات في التكنولوجيا والتصميم والتسويق الرقمي",
    // start blog and track
   track_title: "استكشف مدونة iNoteTech",
track_description: "اكتشف مقالات ثرية تلهم إبداعك وتبقيك في صدارة عالم التكنولوجيا والتصميم والتسويق الرقمي.",

track_front_end_title: "مطوّر واجهات أمامية",
track_front_end_article:
"مطوّر الواجهات الأمامية هو المسؤول عن تحويل التصاميم إلى واجهات تفاعلية يراها المستخدم ويتعامل معها مباشرة. يعتمد هذا المسار على HTML وCSS وJavaScript وReact مع التركيز على تحسين تجربة المستخدم والأداء وتوافق المواقع مع جميع الأجهزة.",

track_back_end_title: "مطوّر خلفيات",
track_back_end_article:
"مطوّر الخلفيات هو العمود الفقري لأي تطبيق حيث يتعامل مع الخوادم وقواعد البيانات والمنطق البرمجي باستخدام Node.js وExpress. يهتم بالأمان والأداء وإدارة البيانات بشكل فعّال.",

track_ui_ux_title: "مصمّم تجربة/واجهة مستخدم",
track_ui_ux_article:
"مصمّم تجربة المستخدم يهتم بكيفية تفاعل المستخدم مع المنتج بينما يركّز تصميم الواجهة على الشكل والتنظيم. هذا التراك يجمع بين الإبداع والتحليل لبناء تجربة استخدام سلسة ومريحة.",

track_full_stack_title: "مطوّر متكامل",
track_full_stack_article:
"المطوّر المتكامل يمتلك مهارات الواجهة الأمامية والخلفية معًا مما يمكّنه من بناء تطبيقات كاملة من البداية حتى الإطلاق. هذا المسار مناسب لمن يحب التحديات والتعلّم المستمر.",

track_mobile_title: "مطوّر تطبيقات جوّال",
track_mobile_article:
"مطوّر تطبيقات الجوال يقوم ببناء تطبيقات تعمل على أنظمة Android وiOS باستخدام React Native وFlutter. هذا المجال يشهد طلبًا متزايدًا ويوفّر فرصًا ممتازة لبناء منتجات رقمية ناجحة.",

track_digital_marketing_title: "التسويق الرقمي",
track_digital_marketing_article:
"التسويق الرقمي يركّز على الترويج للمنتجات والخدمات عبر الإنترنت باستخدام تحسين محركات البحث والإعلانات المدفوعة وتحليل الأداء لتحقيق أفضل النتائج.",

track_graphic_design_title: "مصمّم جرافيك",
track_graphic_design_article:
"مصمّم الجرافيك مسؤول عن بناء الهوية البصرية للعلامات التجارية من الشعارات إلى التصاميم الإعلانية مع الاهتمام بالإبداع والتناسق البصري.",

track_devops_title: "مهندس DevOps",
track_devops_article:
"مهندس DevOps يعمل على أتمتة النشر والتكامل المستمر باستخدام أدوات CI/CD والخدمات السحابية لضمان استقرار وسرعة الأنظمة.",

track_data_analyst_title: "محلّل بيانات",
track_data_analyst_article:
"محلّل البيانات يقوم بتحويل البيانات الخام إلى معلومات مفيدة من خلال التحليل وبناء لوحات معلومات تساعد في اتخاذ قرارات ذكية.",

track_ai_engineer_title: "مهندس ذكاء اصطناعي",
track_ai_engineer_article:
"مهندس الذكاء الاصطناعي يعمل على تطوير أنظمة تعتمد على تعلّم الآلة وتحليل البيانات لبناء حلول ذكية تواكب التطور التكنولوجي.",
companytitle: "أعمالنا | آي نوت تك",
companysubtitle: "مواضيع تلهمك وتواكب آخر صيحات التكنولوجيا والتصميم والتسويق الرقمي",

  "about": {
    "title": "من نحن",
    "experience": "+5 سنوات من الخبرة",
    "description": "آي نوت تك هي وكالة رقمية متخصصة في التسويق الرقمي، تطوير المواقع الإلكترونية، وتطبيقات الهواتف. نصمم حلول مبتكرة تساعد عملاءنا على النمو والتميز في السوق الرقمي. نعمل بشغف ونقدم نتائج حقيقية.",
    "support": {
      "title": "الدعم الفني",
      "text": "في iNote Tech نضمن أداءً سلسًا ودعمًا سريعًا وموثوقًا."
    },
    "solutions": {
      "title": "الحلول التقنية",
      "text": "في آي نوت تك نقدم حزمة متكاملة من الحلول التقنية تشمل التخطيط، التطوير، والتسويق—لنحوّل فكرتك إلى واقع رقمي سلس يحقق أهدافك بأقل جهد وأعلى عائد."
    }
  },
  "vision": {
    "title": "قيادة مستقبل التحول الرقمي",
    "subtitle": "+ رؤيتنا",
    "description": "نؤمن أن التكنولوجيا ليست مجرد أدوات، بل هي أساس التقدم والاستدامة. رؤيتنا أن نصبح الشريك التقني الرائد للشركات الساعية للنمو الذكي، من خلال تقديم حلول برمجية وتسويقية متكاملة تتكيف مع تغيرات السوق وتتجاوز توقعات العملاء.",
    "innovation": {
      "title": "ابتكار مستمر",
      "text": "في آي نوت تك نطور حلولنا باستمرار لنواكب أحدث اتجاهات التكنولوجيا."
    },
    "partnership": {
      "title": "شراكة طويلة الأمد",
      "text": "في آي نوت تك نبني علاقات دائمة مع عملائنا قائمة على الثقة والدعم المستمر لتحقيق نجاح مشترك."
    }
  },


// start join
"join": {
    "title": "انضم إلينا | آي نوت تك",
    "subtitle": "مواضيع تلهمك وتواكب أحدث الاتجاهات في التكنولوجيا، التصميم، والتسويق الرقمي"
  },
  // start login
  login_title: "مرحبًا بعودتك",
  login_subtitle: "من فضلك قم بتسجيل الدخول إلى حسابك",
  login_email: "البريد الإلكتروني",
  login_password: "كلمة المرور",
  login_button: "تسجيل الدخول",
  login_brand: "آي نوت تك",
  login_tagline: "شريكك الرقمي"

        }
      }
    },
    lng: localStorage.getItem("lang") || "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;